export default [
  {
    path: '/listCalorie',
    name: 'listCalorie',
    component: () => import('@/views/menu/dedicatedDiet/listCalorie.vue'),
    meta: {
      pageTitle: 'لیست کالری',
      action: 'show',
      resource: 'SpecialDietCalorieManager',
    },
  },
  {
    path: '/listSupplement',
    name: 'listSupplement',
    component: () => import('@/views/menu/dedicatedDiet/listSupplement.vue'),
    meta: {
      pageTitle: 'لیست مکمل',
      action: 'show',
      resource: 'SupplementManager',
    },
  },
  {
    path: '/listRecommended',
    name: 'listRecommended',
    component: () => import('@/views/menu/dedicatedDiet/listRecommended.vue'),
    meta: {
      pageTitle: 'لیست توصیه ها',
      action: 'show',
      resource: 'RecommendManager',
    },
  },
  {
    path: '/listRecommendedCategory',
    name: 'listRecommendedCategory',
    component: () => import('@/views/menu/dedicatedDiet/listRecommendedCategory.vue'),
    meta: {
      pageTitle: 'لیست دسته بندی توصیه ها',
      action: 'show',
      resource: 'RecommendCategoryManager',
    },
  },
  {
    path: '/listDedicatedFoods',
    name: 'listDedicatedFoods',
    component: () => import('@/views/menu/dedicatedDiet/listFoods.vue'),
    meta: {
      pageTitle: 'لیست غذاها رژیم اختصاصی',
      action: 'show',
      resource: 'SpecialDietFoodListManager',
    },
  },
  {
    path: '/addDedicatedFoodList/:listFoodId?/:clone?',
    name: 'addDedicatedFoodList',
    component: () => import('@/views/menu/dedicatedDiet/addDedicatedFoodList.vue'),
    meta: {
      pageTitle: 'لیست غذاها رژیم اختصاصی',
      action: 'show',
      resource: 'SpecialDietCalorieManager',
    },
  },
  {
    path: '/listDedicatedDiet',
    name: 'listDedicatedDiet',
    component: () => import('@/views/menu/dedicatedDiet/listDedicatedDiet.vue'),
    meta: {
      pageTitle: 'لیست  رژیم اختصاصی',
      action: 'show',
      resource: 'SpecialDietFoodListManager',
    },
  },
  {
    path: '/addDedicatedDietRegime/:regimeId?/:clone?',
    name: 'addDedicatedDietRegime',
    component: () => import('@/views/menu/dedicatedDiet/addDedicatedDietRegime.vue'),
    meta: {
      pageTitle: 'ایجاد رژیم اختصاصی',
      action: 'show',
      resource: 'DietManager',
    },
  },
  {
    path: '/dedicatedDietQuestion',
    name: 'dedicatedDietQuestion',
    component: () => import('@/views/menu/dedicatedDiet/dedicatedDietQuestion.vue'),
    meta: {
      pageTitle: 'سوالات رژیم اختصاصی',
      action: 'show',
      resource: 'QuestionManager',
    },
  },
  {
    path: '/addDedicatedDietQuestion/:QuestionID?',
    name: 'addDedicatedDietQuestion',
    component: () => import('@/views/menu/dedicatedDiet/addDedicatedDietQuestion.vue'),
    meta: {
      pageTitle: 'سوال رژیم اختصاصی',
      action: 'show',
      resource: 'DietManager',
    },
  },
  {
    path: '/PaySpecialDiet/:number?',
    name: 'PaySpecialDiet',
    component: () => import('@/views/menu/dedicatedDiet/PaySpecialDiet.vue'),
    meta: {
      pageTitle: 'پرداخت رژیم اختصاصی',
      action: 'show',
      resource: 'SpecialDietPaymentSms',
    }
  },
]
